export const SET_LOADING = "SET_LOADING"
export const CLEAR_LOADING = "CLEAR_LOADING"
export const SET_SUCCESS = 'SET_SUCCESS';
